import React, { useState } from 'react';
import '../styles/landing.css';

const Demo = () => {
  const [showPdf, setShowPdf] = useState(false);
  const [activeDemo, setActiveDemo] = useState('prepletter');
  
  const handleOpenPdf = (e) => {
    e.preventDefault();
    setShowPdf(true);
  };
  
  const handleClosePdf = () => {
    setShowPdf(false);
  };
  
  const handleOutsideClick = (e) => {
    if (e.target.className === 'pdf-viewer-container') {
      setShowPdf(false);
    }
  };

  return (
    <>
      <section className="demo premium-demo" id="demo">
        <div className="container">
          <div className="demo-content">
            <h2 className="section-title">See PrepLetter in Action</h2>
            <p className="section-subtitle">
              Get a preview of your daily interview prep buddy and quiz system
            </p>
            
            <div className="demo-tabs">
              <button 
                className={`demo-tab ${activeDemo === 'prepletter' ? 'active' : ''}`}
                onClick={() => setActiveDemo('prepletter')}
              >
                📚 PrepLetter Sample
              </button>
              <button 
                className={`demo-tab ${activeDemo === 'quiz' ? 'active' : ''}`}
                onClick={() => setActiveDemo('quiz')}
              >
                🎯 Interactive Quiz
              </button>
            </div>

            <div className="demo-showcase">
              {activeDemo === 'prepletter' && (
                <div className="demo-section">
                  <h3>Daily PrepLetter Email</h3>
                  <p>See exactly what arrives in your inbox with pattern explanations, code examples, and practice problems</p>
                  <div className="demo-buttons">
                    <a
                      href="/sample-problem.pdf"
                      onClick={handleOpenPdf}
                      className="demo-button primary"
                    >
                      📄 View Sample PDF
                    </a>
                    <a href="/learn" className="demo-button secondary">
                      🌐 Read Online
                    </a>
                  </div>
                </div>
              )}
              
              {activeDemo === 'quiz' && (
                <div className="demo-section">
                  <h3>Interactive Quiz System</h3>
                  <p>Experience our quiz system with instant feedback, progress tracking, and unlimited retake opportunities — no signup required</p>
                  <div className="demo-buttons">
                    <a href="/learn/1" className="demo-button primary">
                      ⚡ Try Free Quiz Now
                    </a>
                    <a href="/learn" className="demo-button secondary">
                      📚 Browse All Free Letters
                    </a>
                  </div>
                </div>
              )}
            </div>

            <div className="demo-features-preview">
              <div className="demo-feature">
                <span className="demo-feature-icon">🌍</span>
                <div>
                  <h4>4 Programming Languages</h4>
                  <p>Python, JavaScript, Java, C++</p>
                </div>
              </div>
              <div className="demo-feature">
                <span className="demo-feature-icon">📧</span>
                <div>
                  <h4>Smart Email Delivery</h4>
                  <p>Custom timezone & frequency</p>
                </div>
              </div>
              <div className="demo-feature">
                <span className="demo-feature-icon">🔄</span>
                <div>
                  <h4>Accountability System</h4>
                  <p>Auto-pause & restart features</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PDF Viewer Container */}
      {showPdf && (
        <div className="pdf-viewer-container" onClick={handleOutsideClick}>
          <div className="pdf-viewer">
            <object
              data="/sample-problem.pdf"
              type="application/pdf"
              width="100%"
              height="100%"
            >
              <p>
                Your browser doesn't support embedded PDFs.
                <a href="/sample-problem.pdf" target="_blank" rel="noreferrer">
                  Download the PDF
                </a>{" "}
                instead.
              </p>
            </object>
          </div>
          <div className="pdf-close" onClick={handleClosePdf}>×</div>
        </div>
      )}
    </>
  );
};

export default Demo;
